import { createApp } from 'vue'
import App from './App.vue'
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import BootstrapVue3 from "bootstrap-vue-3";
import router from "./router"

import store from './store/index'

import "bootstrap/dist/css/bootstrap.rtl.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


// import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
// import BootstrapVueNext from "bootstrap-vue-next";

import "./assets/css/Site4.css"
import './registerServiceWorker'


const app=   createApp(App);

// app.use(BootstrapVue);
// app.use(IconsPlugin);


/*VueRouter.createRouter(...)*/

// app.use(BootstrapVueNext);
// app.use(BootstrapVue3);
app.use(router);
app.use(store);


app.mount('#app');
